
export default {
    happens: {
        codeStatus: 0,
    }
}
